import { api } from '../configs/axiosConfigs';

export const createFavorite = async (propertyId: string) => {
  return await api.post(`properties/${propertyId}/favorite`);
};
